import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { newsList } from '@/mocks/news';
import { getFeaturedNews, getHotNews } from '@/utils/news';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuick from '@/pages/home/components/CategoryQuick';
import LatestNews from '@/pages/home/components/LatestNews';
import HotList from '@/pages/home/components/HotList';
import SiteIntro from '@/pages/home/components/SiteIntro';

const hotTags = [
  '轨道交通',
  '天气预警',
  '医保',
  '反诈',
  '电影节',
  '悬疑剧',
  '健康',
  '食品安全',
  '智能家居',
  '演唱会',
];

export default function Home() {
  const featured = getFeaturedNews(5);
  const hot = getHotNews(5);

  return (
    <>
      <Seo
        title="爆料网-权威及时的最新新闻爆料平台"
        description="爆料网致力于提供最新、最全面的新闻爆料和事件报道，涵盖社会热点、娱乐资讯及生活动态，帮助用户第一时间了解重要新闻事件。"
        keywords="爆料网,新闻爆料,最新新闻,热点事件,及时报道,社会新闻,娱乐爆料"
        path="/"
      />

      <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6 md:py-8">
        <h1 className="sr-only">爆料网 — 权威及时的最新新闻爆料平台</h1>

        <HeroCarousel articles={featured} />

        <CategoryQuick />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_340px]">
          <LatestNews articles={newsList} pageSize={5} />

          <aside className="flex flex-col gap-6">
            <HotList articles={hot} />

            <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-accent-500" />
                热门标签
              </h2>
              <div className="mt-3 flex flex-wrap gap-2">
                {hotTags.map((tag) => (
                  <Link
                    key={tag}
                    to={`/search?q=${encodeURIComponent(tag)}`}
                    className="rounded-md border border-background-200 bg-background-100 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    #{tag}
                  </Link>
                ))}
              </div>
            </section>

            <section className="rounded-lg border border-primary-200 bg-primary-50 p-4 md:p-5">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-primary-800">
                <i className="ri-quill-pen-line" />
                有料要爆？
              </h2>
              <p className="mt-2 text-sm leading-6 text-primary-900/80">
                掌握第一手新闻线索？欢迎联系爆料网编辑部，我们将对线索进行核实与跟进报道。
              </p>
              <Link
                to="/contact"
                className="mt-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-600 px-3.5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                提供线索
                <i className="ri-arrow-right-line" />
              </Link>
            </section>
          </aside>
        </div>

        <SiteIntro />
      </div>
    </>
  );
}